import { vnModule_knockoutJS } from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import { XMLHttpRequestHandler, XMLHttpRequestHandler_requestType  } from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import {configPromotionsEdit_template} from "../components/templates/configPromotionsEdit_template";
import {vn_app_zone_notification} from "../../vendor/valnet/valnet_jslib/vnApp/vn_app_zone_notification";

declare var ko: any;
declare var page: any;
declare var CKEDITOR: any;
CKEDITOR.timestamp = '1.2.0';

let contentEditor;

export class config_promotion_edit extends vnModule_knockoutJS{
    protected elementsEdit : configPromotionsEdit_template
    protected XHRHdl: XMLHttpRequestHandler;
    protected XHRHdlCaller: string;
    protected _isLeavePageWarningNeeded: boolean = true;

    buildContent(): Array<Element> {

        this.elementsEdit = new configPromotionsEdit_template('config_promotion_edit_template', this.viewModel, this)
        return [this.elementsEdit.build()]
    }

    protected getModuleName(): string {

        return "config_promotion_edit";
    }

    public fillPage() {

        this.getReferences()

    }

    private getReferences() {

        this.loadingIn(this.elementsEdit.builtTemplate);

        let idBrand = this.getVnAppZone().getApp().params.idBrand;
        let usrReq_url: string = '/api/brand/' + idBrand + "/promotion/references/";
        let usrReq_params: Array<Array<string>> = [];
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

        this.XHRHdl.onReadyStateFunction = this.onGetReferencesReturn;
        this.XHRHdl.execute();
    }

    private onGetReferencesReturn(req, obj) {

        return function () {

            obj.manageResponse(req, obj, function () {

                let response = JSON.parse(req.request.response);
                obj.elementsEdit.setPermissions(response.permissions || []);
                obj.elementsEdit.setZones(response.zones || []);
                obj.elementsEdit.setPresetOptions(response.presets || []);

                // get data
                obj.getDataForEdit();
            });
        }
    }

    private getDataForEdit() {

        let url : string = '/api/brand/' + this.getVnAppZone().app.params.idBrand + '/promotion/edit/' + this.getVnAppZone().app.params.id + '/';
        let request_parameters : Array<Array<string>> = [];
        this.XHRHdl = new XMLHttpRequestHandler(url, request_parameters, this);
        this.XHRHdl.onReadyStateFunction = this.onGetDataForEdit;
        this.XHRHdl.execute();
    }

    private onGetDataForEdit(req, obj) {

        return function () {
            obj.manageResponse(req, obj, function () {

                let responseParsed = JSON.parse(req.request.response);
                let data = responseParsed.data
                obj.elementsEdit.setId(data.id || '');
                obj.elementsEdit.setName(data.name || '');
                obj.elementsEdit.setIsAvailable(data.isAvailable == null ? true : data.isAvailable);
                obj.elementsEdit.setLoginStatus(data.isLoginUser || 'null');
                obj.elementsEdit.setPremiumStatus(data.isPremiumUser|| 'null');
                obj.elementsEdit.setAdBlockStatus(data.isAdBlockUser|| 'null');
                obj.elementsEdit.setBotRequestStatus(data.isBotRequest|| 'null');
                obj.elementsEdit.setListItemStatus(data.has5ListItemsOrMore || 'null');
                obj.elementsEdit.setPushNotificationStatus(data.isPushNotificationSubscribed || 'null');
                obj.elementsEdit.setHighEngagementStatus(data.isHighlyEngaged || 'null');
                obj.elementsEdit.setHtml(data.html || '');
                obj.elementsEdit.setCss(data.css || '');
                obj.elementsEdit.setContentType(data.preset ? 'preset' : 'custom');
                obj.elementsEdit.setPreset(data.preset || '');
                obj.elementsEdit.setFilterConfig(data.filterConfig || {});
                obj.elementsEdit.setGeos(data.geos || []);
            });

            obj.loadingOut(obj.elementsEdit.builtTemplate);
        }
    }

    protected save(){

        this.loadingIn(this.elementsEdit.builtTemplate);

        let idBrand = this.getVnAppZone().getApp().params.idBrand;

        let formReq_url: string = '/api/brand/' + idBrand + "/promotion/save/";
        let formReq_params: Array<Array<string>> = [];

        let subViewModel = JSON.parse(ko.toJSON(this.elementsEdit.getViewModelForRequest()));
        formReq_params.push(['data', ko.toJSON(subViewModel)]);

        let XHRHdl: XMLHttpRequestHandler = new XMLHttpRequestHandler(formReq_url, formReq_params, this);
        XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;
        XHRHdl.onReadyStateFunction = (function (req, obj) {

            return function () {

                obj.manageResponse(req, obj, function () {

                    page.redirect('/brand/' + idBrand + "/config/promotion/");

                    if (req.request.status === 200) {
                        obj.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_SUCCESS, "Promotion saved !");
                    }
                });
                obj.loadingOut(obj.elementsEdit.builtTemplate);
            }
        });
        XHRHdl.execute();
    }

    public onClickCancel(){

        if (this.XHRHdl) {
            this.XHRHdl.cancelAndReset();
        }

        page.redirect("/brand/" + this.getVnAppZone().app.params.idBrand + "/config/promotion/" )
    }

    protected getSuggestions(keyword, idSourceElement) {
        this.XHRHdlCaller = "getSuggestions_" + idSourceElement;

        if (idSourceElement == "filterAutocompleteGEO_template") {
            this.getGeoSuggestion(keyword, idSourceElement);
        }
    }

    public getGeoSuggestion(keyword, idElement) {
        if (this.XHRHdl) {
            this.XHRHdl.cancelAndReset();
        }

        let subViewModel = {filter: {keyword: keyword}, idElement: idElement};
        let usrReq_url: string = '/api/brand/' + this.getVnAppZone().app.params.idBrand + "/promotion/search/geo/";
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)]);

        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
        this.XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;
        this.XHRHdl.onReadyStateFunction = this.onFilterRequestReturn;
        this.XHRHdl.execute();
    }

    protected onFilterRequestReturn(req, obj) {

        return function () {
            obj.manageResponse(req, obj, function(){
                let response = JSON.parse(req.request.response);

                if (obj.XHRHdlCaller == "getSuggestions_filterAutocompleteGEO_template") {
                    obj.elementsEdit.filterGEO.setOptions(response.data.availableGeos);
                }
            });
        }
    }

    protected onAutocompleteInputClick(idElement) {

    }

    protected onAutocompleteOptionChange(idElement) {

        if (idElement == "filterAutocompleteGEO_template"){
            let geos = this.elementsEdit.getTemplateViewModel().geos();
            let chosenGeo = this.elementsEdit.filterGEO.getTemplateViewModel().optionObj();
            let duplicateGeo = false;

            for (let geo of geos) {
                if (geo.id === chosenGeo.id) {
                    duplicateGeo = true;
                    break;
                }
            }

            if (!duplicateGeo) {
                geos.push(chosenGeo);
                this.elementsEdit.getTemplateViewModel().geos(geos);
            }
        }
    }
}



// WEBPACK FOOTER //
// ./js/modules/config_promotion_edit.ts